import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withDigitalData } from '../../utils/DigitalDataContext';
import { withLabels } from '../../utils/LabelsContext';
import { withProduct } from '../../utils/ProductContext';
import ComboSpecifications from '../ComboSection/ComboSpecifications';
import SpecificationTable from '../SpecificationTable/SpecificationTable';
import Drawer from '../ui/Drawer/Drawer';
import ScrollTo from '../ui/ScrollTo/ScrollTo';
import { useProductTopSpecifications } from './hooks/useProductTopSpecifications';
import { ProductTopSpecificationsStyle } from './ProductTopSpecifications.style';

const ProductTopSpecifications = ({ product, labels, scollToElementId, digitalData, appCtx }) => {
  const hookData = useProductTopSpecifications({ product, labels, scollToElementId, digitalData, appCtx });

  const {
    topSpecifications,
    specifications,
    topSpecificationsTitle,
    viewMoreText,
    specificationsTitle,
    comboData,
    isDesktop,
    isSodimacSA,
    drawerToggleState,
    handleViewMoreClick,
    shouldShowDivider,
    hasComboSpecifications,
    shouldRender,
  } = hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <div className="specifications-container fa--product-characteristic-features">
        <div className="specifications-title">{topSpecificationsTitle}</div>
        <div className="specifications-list">
          <ul>
            {topSpecifications.map((spec) => (
              <li key={spec.name}>
                <strong>{spec.name}</strong>: {spec.value}
              </li>
            ))}
          </ul>
        </div>
        {isDesktop ? (
          <ScrollTo scrollToElementId={scollToElementId} isSoCom={isSodimacSA} />
        ) : (
          <>
            <button type="button" onClick={handleViewMoreClick} className="view-more">
              {viewMoreText}
            </button>
            <Drawer toggleState={drawerToggleState} heading={specificationsTitle} isLoading={false} type="secondary">
              {hasComboSpecifications ? (
                <ComboSpecifications comboItems={comboData.comboItems} isDrawer labels={labels} />
              ) : (
                <SpecificationTable specifications={specifications} type="secondary" />
              )}
            </Drawer>
          </>
        )}
      </div>
      {shouldShowDivider && <div className="specifications-divider" />}
      <style jsx>{ProductTopSpecificationsStyle}</style>
    </>
  );
};

ProductTopSpecifications.defaultProps = {
  scollToElementId: null,
};
ProductTopSpecifications.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  scollToElementId: PropTypes.string,
  digitalData: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export { ProductTopSpecifications };
export default withLabels(withProduct(withDigitalData(withApplicationContext(ProductTopSpecifications))));
